import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { Insert, Tables } from "@/types/database";
import { throwIfError } from "./_supabaseErrors";

export type QuoteLineItem = Tables<"quote_line_items">;
export type QuoteLineItemInsert = Insert<"quote_line_items">;

export async function listQuoteLineItems(quoteId: string): Promise<QuoteLineItem[]> {
  const { data, error } = await supabase
    .from("quote_line_items")
    .select("*")
    .eq("quote_id", quoteId)
    .order("sort_index", { ascending: true });
  throwIfError(error);
  return data ?? [];
}

export async function listQuoteLineItemsForQuotes(quoteIds: string[]): Promise<QuoteLineItem[]> {
  if (quoteIds.length === 0) return [];
  const { data, error } = await supabase
    .from("quote_line_items")
    .select("*")
    .in("quote_id", quoteIds)
    .order("sort_index", { ascending: true });
  throwIfError(error);
  return data ?? [];
}

export async function createQuoteLineItems(rows: QuoteLineItemInsert[]): Promise<QuoteLineItem[]> {
  if (rows.length === 0) return [];
  const { data, error } = await supabase.from("quote_line_items").insert(rows).select("*");
  throwIfError(error);
  return data ?? [];
}

export async function replaceQuoteLineItems(
  quoteId: string,
  rows: Omit<QuoteLineItemInsert, "quote_id">[]
): Promise<QuoteLineItem[]> {
  const { error: delErr } = await supabase.from("quote_line_items").delete().eq("quote_id", quoteId);
  throwIfError(delErr);
  return createQuoteLineItems(rows.map((r) => ({ ...r, quote_id: quoteId })));
}

export const quoteLineItemsQueryOptions = (quoteId: string) =>
  queryOptions({
    queryKey: ["quoteLineItems", quoteId] as const,
    queryFn: () => listQuoteLineItems(quoteId),
    enabled: Boolean(quoteId)
  });
